let navigateTo = null;

export const setNavigateFunction = (navigateFn) => {
  navigateTo = navigateFn;
};

export const redirectToServerErrorPage = () => {
  if (navigateTo) {
    navigateTo('/server-error');
  } else {
    window.location.href = '/server-error';
  }
};
